import authHttp, { API_ROOT } from "../auth-http";

export const PerspectivesService = {
  getAll() {
    return authHttp.get(`${API_ROOT}/perspectives/home`);
  },
};

export default PerspectivesService;
